import Recat, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Select, message, Spin } from 'antd'
import { SGeneralForms } from 'shj-components'
import { refundApplyGet, getEnum } from "@/services/fmsServices";
import { getBankList, getBankAreaList, getBankBranchList } from "@/services/fmsConfig";
import dayjs from 'dayjs'
const { Option } = Select;
export const AddOrEditForm = Recat.forwardRef((props: any, ref) => {
  const { editData } = props
  const formRef: any = useRef()
  const [spinning, setSpinning] = useState(false)
  const [bankShow, setBankShow] = useState(true)
  const [refundData, setRefundData] = useState<any>(null)
  const [bankAreaList, setBankAreaList] = useState<any>([])
  const [bankList, setBankList] = useState<any>([])
  const [bankBranchList, setBankBranchList] = useState<any>([])
  let reqMeg = '不能为空'
  useImperativeHandle(ref, () => ({
    validateFields: () => formRef.current?.onFormRef()?.validateFields(),
  }));
  useEffect(() => {
    initFn()
  }, [])
  const initFn = async () => {
    setSpinning(true)
    refundApplyGet(editData.id).then((res)=>{
      setSpinning(false)
      setRefundData(res)
      const refundAmounts = {
        engineeringFeeCanRefundAmount: 0,
        orderDesignFeeCanRefundAmount: 0,
        commodityFeeCanRefundAmount: 0,
        engineeringFeeRefundAmount: 0,
        orderDesignFeeRefundAmount: 0,
        commodityFeeRefundAmount: 0,
      };
      if (res.refundApplyTransDtlList?.length) {
        res.refundApplyTransDtlList.forEach((item) => {
          const { transactionType, canRefundAmount, refundAmount } = item;
          if (transactionType === 'constructionFee') {
            refundAmounts.engineeringFeeCanRefundAmount = canRefundAmount;
            refundAmounts.engineeringFeeRefundAmount = refundAmount;
          } else if (transactionType === 'designFee') {
            refundAmounts.orderDesignFeeCanRefundAmount = canRefundAmount;
            refundAmounts.orderDesignFeeRefundAmount = refundAmount;
          } else if (transactionType === 'retailAmountFee') {
            refundAmounts.commodityFeeCanRefundAmount = canRefundAmount;
            refundAmounts.commodityFeeRefundAmount = refundAmount;
          }
        });
      }
      formRef.current?.onFormRef()?.setFieldsValue({
        ...res,
        applyTime: res?.applyTime ? dayjs(res.applyTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
        receiveDate: res?.receiveDate ? dayjs(res.receiveDate).format('YYYY-MM-DD HH:mm:ss') : undefined,
        confirmDate: res?.confirmDate ? dayjs(res.confirmDate).format('YYYY-MM-DD HH:mm:ss') : undefined,
        ...refundAmounts,
      })
      getBankAddress()
    }).catch(err=>{
      setSpinning(false)
    })
  }
  const getBankAddress = () =>{
    const { areaCode, bankCode } = formRef.current?.onFormRef()?.getFieldsValue() || {};
    if (areaCode && bankCode) {
      setBankShow(false)
      getBankBranchList({ bankCode, areaCode }).then((res) => {
        setBankBranchList(res)
        // formRef.current?.updateState({
        //   bankBranchList: res
        // });
      });
    }else{
      setBankShow(true)
    }
  }
  const getBankNetworkNumber = (value,data) =>{
    console.log(value)
    formRef.current?.onFormRef()?.setFieldsValue({
      bankNetworkNumber: data.key
    })
  }
  const getOptions = async () => {
    const bankLists = await getBankList({orderBys: [
      {
        columnName: '',
        asc: false
      }
    ]})
    const bankAreaLists = await getBankAreaList({orderBys: [
      {
        columnName: '',
        asc: false
      }
    ]})
    let accountNatureList = await getEnum('com.shj.saas.plus.fms.enums.refund.AccountNatureEnum')
    setBankAreaList(bankAreaLists)
    setBankList(bankLists)
    return Promise.resolve({
      bankList: bankLists,
      bankAreaList:bankAreaLists,
      bankBranchList: [],
      accountNatureList
    })
  }
  const filterOption = (input: any, option: any) => {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  return (
    <Spin spinning={spinning}>
      <SGeneralForms
        ref={formRef}
        httpOptionsFn={getOptions}
        configs={[
          {
            formItem: [
              { label: 'id', name: 'id', hidden: true },
              {
                label: '退款申请单号',
                name: 'billNo',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '退款类型',
                name: 'refundTypeName',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '申请时间',
                name: 'applyTime',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '支付方式',
                name: 'payTypeName',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '退款状态',
                name: 'refundStateName',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              
              {
                label: '是否原路退回',
                name: 'backTrackFlag',
                type: 'switch',
                spanCol: 8,
                comConfig: {
                  disabled: true,
                  checkedChildren: '是',
                  unCheckedChildren: '否',
                },
              },
              {
                label: '转入订单号',
                name: 'transferInOrderId',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '确认退款时间',
                name: 'receiveDate',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '已退款时间',
                name: 'confirmDate',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                spanCol: 12,
                label: '是否退款',
                name: 'realRefundFlag',
                type: 'radio',
                required: true,
                comConfig: {
                  disabled: true,
                  options: [
                    { label: '是', value: true },
                    { label: '否', value: false },
                  ],
                },
              },
            ],
          },
          {
            title: '客户收款信息',
            formItem: [
              {
                label: '开户名',
                name: 'accountName',
                spanCol: 12,
                required: editData.type === 'edit' ? true : false,
                rules: [{ required: editData.type === 'edit' ? true : false, message: reqMeg }],
                comConfig: {
                  disabled: editData.type !== 'edit'
                },
              },
              {
                label: '开户银行卡号',
                name: 'accountNumber',
                spanCol: 12,
                required: editData.type === 'edit' ? true : false,
                rules: [{ required: editData.type === 'edit' ? true : false, message: reqMeg }],
                comConfig: {
                  disabled: editData.type !== 'edit'
                },
              },
              {
                label: '开户银行名称',
                name: 'bankCode',
                spanCol: 12,
                required: editData.type === 'edit' ? true : false,
                rules: [{ required: editData.type === 'edit' ? true : false, message: reqMeg }],
                children: (
                  <Select disabled={editData.type !== 'edit'} showSearch filterOption={filterOption} onChange={getBankAddress}>
                  {bankList && bankList.map((item, index) => {
                    return (
                      <Option key={item.bankCode} value={item.bankCode}>
                        {item.bankName}
                      </Option>
                    );
                  })}
                </Select>
                )
              },
              {
                label: '开户城市',
                name: 'areaCode',
                spanCol: 12,
                required: editData.type === 'edit' ? true : false,
                rules: [{ required: editData.type === 'edit' ? true : false, message: reqMeg }],
                children: (
                  <Select disabled={editData.type !== 'edit'} showSearch filterOption={filterOption} onChange={getBankAddress}>
                  {bankAreaList && bankAreaList.map((item, index) => {
                    return (
                      <Option key={item.areaCode} value={item.areaCode}>
                        {item.areaName}
                      </Option>
                    );
                  })}
                </Select>
                )
              },
              {
                label: '开户银行网点',
                name: 'bankAddress',
                spanCol: 12,
                required: editData.type === 'edit' ? true : false,
                isHideItem: bankShow,
                rules: [{ required: editData.type === 'edit' ? true : false, message: reqMeg }],
                children: (
                  <Select disabled={editData.type !== 'edit'} showSearch filterOption={filterOption} onChange={getBankNetworkNumber}>
                  {bankBranchList && bankBranchList.map((item, index) => {
                    return (
                      <Option key={item.branchCode} value={item.branchName}>
                        {item.branchName}
                      </Option>
                    );
                  })}
                </Select>
                )
              },
              {
                label: '银行网点联行号',
                name: 'bankNetworkNumber',
                isHideItem: bankShow,
                spanCol: 12,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '账户类型',
                name: 'accountNature',
                spanCol: 12,
                type: 'select',
                data: 'accountNatureList',
                required: editData.type === 'edit' ? true : false,
                rules: [{ required: editData.type === 'edit' ? true : false, message: reqMeg }],
                comConfig: {
                  fieldNames: {  value: 'key', label: 'description'  },
                  disabled: editData.type !== 'edit'
                },
              },
            ]
          },
          {
            title: '退款金额信息',
            formItem: [
              {
                label: '工程交款金额',
                name: 'engineeringFeeCanRefundAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '设计费交款金额',
                name: 'orderDesignFeeCanRefundAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '商品款交款金额',
                name: 'commodityFeeCanRefundAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '工程应退金额',
                name: 'engineeringFeeRefundAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '设计费应退金额',
                name: 'orderDesignFeeRefundAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '商品款应退金额',
                name: 'commodityFeeRefundAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '工程款违约金',
                name: 'constructionPenaltyAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '违约责任人',
                name: 'penaltyPersonDisplay',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '赠品扣除金额',
                name: 'giftCostAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '赠品扣除说明',
                name: 'giftCostDescription',
                spanCol: 24,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '形象保护费',
                name: 'imgProtectionAmount',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '退款原因',
                name: 'reasonDisplay',
                spanCol: 16,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '原因备注',
                name: 'reasonDescription',
                spanCol: 24,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '退款支付状态',
                name: 'payStateName',
                spanCol: 8,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '支付异常原因',
                name: 'payException',
                spanCol: 12,
                comConfig: {
                  disabled: true
                },
              },
              {
                label: '支付异常处理结果',
                name: 'payExceptionDescription',
                spanCol: 12,
                comConfig: {
                  disabled: true
                },
              },
            ]
          }
        ]}
      />
    </Spin>
  )
})
